import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import { IconWriting } from 'components/icons';

import { Button, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import useGrafSign, { GrafSign } from 'hooks/useGrafSign';
import AddGraphSigns from 'components/signs/AddGraphSigns';
import SideModal from 'components/SideModal';
import ListGraphSigns from 'components/signs/ListSigns';

const SignSection = () => {
    const theme = useTheme();
    const intl = useIntl();
    const [selected, setSelected] = useState<GrafSign | undefined>();
    const { grafSigns } = useGrafSign();
    const [isSignModalOpen, setIsSignModalOpen] = useState<boolean>(false);
    const [listSigns, setListSigns] = useState<boolean>(false);

    const closeSignsModal = () => {
        setIsSignModalOpen(false);
    };

    const handleToggle = () => {
        setListSigns(true);
    };

    const anchorRef = useRef<any>(null);

    useEffect(() => {
        if (listSigns && grafSigns.length === 0) {
            setListSigns(false);
            setIsSignModalOpen(true);
        }
    }, [grafSigns, listSigns]);

    useEffect(() => {
        !isSignModalOpen && selected && setSelected(undefined);
    }, [isSignModalOpen]);

    return (
        <>
            <Tooltip title={intl.formatMessage({ id: 'MI_FIRMA' })} placement="bottom">
                <Button
                    ref={anchorRef}
                    aria-label={intl.formatMessage({ id: 'MI_FIRMA' })}
                    sx={{
                        backgroundColor: theme.palette.grey[100],
                        color: theme.palette.grey[900],
                        padding: '8px',
                        minWidth: '0',
                        borderRadius: '8px',
                        '&:hover': {
                            backgroundColor: theme.palette.grey[200]
                        },
                        '&:focus': {
                            color: theme.palette.grey[900]
                        },
                        transition: 'all .2s ease-in-out',
                        mr: '24px'
                    }}
                    onClick={handleToggle}
                >
                    <IconWriting stroke={1.5} aria-hidden="true" />
                </Button>
            </Tooltip>

            {isSignModalOpen && (
                <SideModal isOpen={isSignModalOpen} onClose={() => setIsSignModalOpen(false)}>
                    <AddGraphSigns
                        title={selected ? intl.formatMessage({ id: 'EDITAR_FIRMA' }) : intl.formatMessage({ id: 'AÑADIR_NUEVA_FIRMA' })}
                        onClose={closeSignsModal}
                        sign={selected}
                        forceDefault={grafSigns.length === 0}
                    />
                </SideModal>
            )}
            {listSigns && (
                <SideModal isOpen={listSigns} onClose={() => setListSigns(false)}>
                    <ListGraphSigns
                        addSign={() => {
                            setListSigns(false);
                            setIsSignModalOpen(true);
                        }}
                        updateSign={(sign: GrafSign) => {
                            setListSigns(false);
                            setSelected(sign);
                            setIsSignModalOpen(true);
                        }}
                        onClose={() => setListSigns(false)}
                    ></ListGraphSigns>
                </SideModal>
            )}
        </>
    );
};

export default SignSection;
